import React, { useEffect, useState } from "react";
import Loader from "../../generalComponents/Loader";
import "../../styles/MenuProcesos.css";

const CrudIndicatorsForm = ({
	processToEdit,
	closeModal,
	setGoToIndicator,
}) => {
	const initialForm = {
		initialDate: null,
		finalDate: null,
	};
	const [form, setForm] = useState(initialForm);
	const [loading, setLoading] = useState(false);
	useEffect(() => {}, []);

	const handleChange = (e) => {
		setForm({
			...form,
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log("fecha inicial:", form.initialDate);
		if (form.initialDate === null) {
			alert("Debe seleccionar una fecha inicial");
			return;
		}
		if (form.finalDate === null) {
			alert("Debe seleccionar una fecha final");
			return;
		}
		if (form.initialDate > form.finalDate) {
			alert("No puede ser la fecha final anterior a la inicial...");
			return;
		}
		localStorage.setItem("initialDate", form.initialDate);
		localStorage.setItem("finalDate", form.finalDate);
		setGoToIndicator(true);
		setLoading(true);

		// handleReset();
		setLoading(false);
		closeModal();
	};

	return (
		<div className="conten0">
			<div className="conten1">
				<h3 className="titulo1"></h3>

				<form onSubmit={handleSubmit} className="form-procesos">
					{processToEdit && (
						<h2 className="title2-account">
							Generando Indicador: {processToEdit.process}
						</h2>
					)}
					<h2 className="title3-account">
						Seleccione Rango de fecha para generar el indicador
					</h2>
					{loading ? (
						<Loader />
					) : (
						<div>
							<label className="title3-account">Fecha Inicial</label>
							<input
								type="date"
								name="initialDate"
								placeholder="Fecha Inicial"
								onChange={handleChange}
								value={form.initialDate}
								className="input1"
							/>
							<label className="title3-account">Fecha Final</label>
							<input
								type="date"
								name="finalDate"
								placeholder="Fecha final"
								onChange={handleChange}
								value={form.finalDate}
								className="input1"
							/>

							<hr />
							<input
								type="submit"
								value="Enviar"
								className="btn-send-reg-asign"
							/>
							{/* <input
								type="reset"
								value="Limpiar"
								// onClick={handleReset}
								className="btn-clean-reg-asign"
							/> */}
							<input
								type="reset"
								value="Cerrar"
								onClick={closeModal}
								className="btn-close-reg-asign"
							/>
						</div>
					)}
				</form>
			</div>
		</div>
	);
};

export default CrudIndicatorsForm;
